import { createFileRoute } from '@tanstack/react-router';
import { InfoPage } from '../components/InfoPage.js';

export const Route = createFileRoute('/terms-and-conditions')({
  component: () => <InfoPage title="Terms and Conditions" />,
});
